<style scoped lang="scss">
  .wrap {
    width: 100%;
    display: flex;
    margin-top: 42px;
    align-items: stretch;
  }

  .left {
    width: 411px;
    height: 325px;
    border: 1px solid #dcdfe6;
  }


  .item1 {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;
    height: 60px;
    margin-top: -50px;

    .icon {
      display: inline-block;
      width: 5px;
      height: 16px;
      background: #419fff;
    }

    .txt {
      display: inline-block;
      font-weight: 400;
      font-size: 16px;
      color: #303133;
      margin-left: 12px;
    }
  }

  .item2 {
    width: 100%;
    height: 270px;

    //border: 1px solid #DCDFE6;
    .header {
      width: 411px;
      padding: 20px 15px 6px 15px;

      .title {
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        color: #303133;
      }

      .circle {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #e6a23c;
        margin: 0 9px 0 13px;
      }

      .tag-left {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #606266;
      }

      .tag-right {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #606266;
      }
    }

    .reason {
      width: 100%;
      height: 270px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin-top: 15px;
      overflow: auto;
      margin-bottom: 10px;

      .reason__item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        margin-left: 15px;

        .content {
          //display: flex;
          //align-items: center;
          display: grid;
          grid-template-columns: 20px 150px 200px 120px;
          width: 100%;

          .sort {
            height: 17px;
            width: 17px;
            border-radius: 50%;
            color: white;
            background-color: #909399;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .title {
            font-size: 12px;
            line-height: 22px;
            color: #303133;
            margin-left: 10px;
            width: 150px;
          }

          //.label {
          //  color: #606266;
          //  margin-left: 8px;
          //  width: 120px;
          //  overflow: hidden;
          //}

          .chart {
            height: 8px;
            background-color: #419fff;
            margin-left: 8px;
            width: 200px;
            margin-top: 6px;
          }

          .label {
            font-size: 12px;
            line-height: 18px;
            color: #e6a23c;
            width: 120px;
            margin-left: 20px;
          }

          .label-l,
          .label-r {
            margin-left: 5px;
          }

          .label-r {
            color: #f56c6c;
          }
        }
      }
    }
  }
  .right {
    flex: 1;
    height: 325px;
    margin-left: 18px;
    border: 1px solid #dcdfe6;
    padding: 20px 28px 46px 28px;
    display: flex;

    .item2 {
      width: 100%;
      height: 300px;

      .header {
        color: #303133;
        font-size: 16px;
        margin-top: -10px;
      }

      #tableChart {
        width: 100%;
        height: 310px;
      }
    }
  }
</style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/custom/equipment/energy/energyReport" ref="yt" getKey="rows" :columns="columns" @afterGet="afterGet" @selectionChange="selectionChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('tongjishijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.begin" :end.sync="yt.conditions.end"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-button @click="yt.get(1)" type="primary" plain size="mini">
            {{$t('sousuo')}}
          </el-button>
          <el-button @click="clear()" size="mini">{{$t('chongzhi')}} </el-button>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>
<script>
  const date = new Date();
  const end = new Date(date.getFullYear(), date.getMonth()+1, 0, 23, 59, 59).getTime();
  const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
  export default{
        name:"sida_report_energy_data_index",
        data(){
            return{
              list:[],
              conditions: {
                begin: begin,
                end: end,
                equipmentIds:[]
              },
              columns:[
              {
                  label: 'shebeibianma',
                  prop: 'equipment.sn',
              },
              {
                  label: 'shebeimingcheng',
                  prop: 'equipment.name',
              },
              {
                  label: 'yibiaohao',
                  prop: 'equipment.meterNo',
              },
              {
                  label: 'yibiaomingcheng',
                  prop: 'equipment.meterName',
              },
              {

                  label: 'kaishishijian',
                  prop: 'beginDate',
                  type:'time',
              },

              {
                  label: 'jieshushijian',
                  prop: 'endDate',
                  type:'time',
              },
              {
                  label: 'yongdianliang',
                  prop: 'useEnergy',
              },
              ]
          }
      },created(){
          setTimeout(() => {
              this.yt.conditions = this.conditions
              this.yt.isShowPagination=false
              this.yt.isShowSummary = true
              this.yt.getSummaries = this.summaryMethod
            this.$nextTick(()=>{
              this.utils.event_hub.$emit('RESIZE')
            })
          }, 300);
      },methods:{
      afterGet(){
        setTimeout(() => {
              for (let i = 0; i < this.yt.list.length; i++) {
               this.$set(this.yt.list[i], 'useEnergy', this.yt.list[i].useEnergy.toFixed(3))
              }
        },10)
      },
        clear(){
          this.conditions.begin= begin,
          this.conditions.end=end,
          this.conditions.equipmentIds=[]
          this.yt.conditions = this.conditions
          this.yt.list =[]
        },
        summaryMethod(params){
          const { columns, data } = params;
          const sums = [];
          columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if(column.property==='useEnergy'){
            if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += ' kWh';
          } else {
            sums[index] = '';
          }
          }
        });
        return sums;
      }
    }
  }
</script>
